import { style } from '@vanilla-extract/css'
import { inputGroup, inputLine } from '~/components/Form/Form.css'
import { vars } from '~/styles/theme.css'

export const toggleLabel = style({
  display: 'flex',
  alignItems: 'center',
  marginRight: 'auto', // do not take the full line (void click can target label line)
  fontWeight: vars.font.body.weight,
  whiteSpace: 'nowrap',
  width: 'auto',
  gap: 6,
  height: 48,

  selectors: {
    [`${inputLine} > &`]: {
      // Position relative to bottom, to match both lines with labels or not
      alignSelf: 'flex-end'
    },
    [`${inputGroup} > ${inputLine} > &`]: {
      // Input group already merges label line
      marginTop: 0
    }
  }
})

export const container = style({
  width: 46,
  maxWidth: 46,
  height: 29,
  backgroundColor: vars.color.white,
  border: `1px solid ${vars.color.medium}`,
  borderRadius: 50,
  cursor: 'pointer',
  display: 'flex',
  padding: '0 2px',
  alignItems: 'center'
})

export const containerSmall = style({
  width: 36,
  maxWidth: 36,
  height: 20,
  fontSize: vars.font.smallNormal.size
})

export const isDisabled = style({
  cursor: 'not-allowed',
  opacity: 0.5
})

export const containerOn = style({
  borderColor: vars.color.dark,
  backgroundColor: vars.color.dark
})

export const handle = style({
  width: 20,
  height: 20,
  backgroundColor: vars.color.medium,
  borderRadius: '50%',
  selectors: {
    [`${containerSmall} > &`]: {
      width: 14,
      height: 14
    }
  }
})

export const handleOn = style({
  backgroundColor: vars.color.white
})
